import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControlLabel from '@mui/material/FormControlLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { FeatureMetadata, SubscriptionPlan } from '@/types/subscription';
import { FeatureDialogProps } from '../types';

export function FeatureEditDialog({ open, onClose, onSave, onChange, editingFeature }: FeatureDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>
        {editingFeature?.key ? `Modify Protocol: ${editingFeature.name}` : 'Forge New Imperial Feature'}
      </DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 1 }}>
          <TextField
            fullWidth
            label="Feature Key (unique, lowercase)"
            disabled={!!editingFeature?.createdAt} // Immutable key after creation
            value={editingFeature?.key || ''}
            onChange={(e) => onChange({ ...editingFeature, key: e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, '') })}
            helperText="Permanent identifier. Use snake_case."
          />
          <TextField
            fullWidth
            label="Display Name"
            value={editingFeature?.name || ''}
            onChange={(e) => onChange({ ...editingFeature, name: e.target.value })}
          />
          <TextField
            fullWidth
            label="Brief Description"
            multiline
            rows={2}
            value={editingFeature?.description || ''}
            onChange={(e) => onChange({ ...editingFeature, description: e.target.value })}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={editingFeature?.showOnPricing ?? false}
                onChange={(e) => onChange({ ...editingFeature, showOnPricing: e.target.checked })}
              />
            }
            label="Publicly visible on Pricing Protocol"
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 3 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={() => onSave(editingFeature || {})}
          disabled={!editingFeature?.key || !editingFeature?.name}
        >
          Accept
        </Button>
      </DialogActions>
    </Dialog>
  );
}
